import { Component } from "@angular/core";
import { MdDialog, MdDialogRef, MdSnackBar } from "@angular/material";
import { GenerateService360LicenseComponent } from "./generate-service360-license/generate-service360-license.component";
import { FormBuilder, FormGroup } from "@angular/forms";
import { LicenseService } from "../../services/LicenseService";
import { AppLoaderService } from "../../../services/app-loader/app-loader.service";
import Swal from "sweetalert2";
import { set } from "core-js/core/dict";
import { Service360ViewActivationDetailComponent } from "./service360-view-activation-details/service360-view-activation-details.component";
import { ActivatedRoute, Router } from "@angular/router";
import { AdalService } from "../../shared/adal.service";
import { ExportToCSVService } from "../../services/ExportToCSVService";
import { PagerService } from "../../services/PagerService";
import { UserService } from "../../services/UserService";
import { Service360FilterPipe } from "./pipes/service360FilterPipe";

@Component({
    selector:'license-service360',
    template:require('./service360.component.html'),
    styles:[require('./service360.component.css')],
})
export class LicenseModuleService360Component{
    filterBillToName='';
    filterShipToName='';
    filterLicenseKey='';
    searchBillToName='';
    searchShipToName='';
    searchLicenseKey='';
    BillToList=[];
    ShipToList=[];
    service360LicenseList=[];
    originalService360LicenseList=[];
    filteredService360LicenseList=[];
    errorMessage='';
    pager:any={};
    pagedItems: any[];
    IsAddEdit;
    IsDelete;
    ProductId;
    currentSortColumn;
    currentSortOrder;
    constructor(
        private dialog:MdDialog,
        private licenseService:LicenseService,
        private appLoader:AppLoaderService,
        private snackBar:MdSnackBar,
        private adalService:AdalService,
        private router:Router,
        private exportService:ExportToCSVService,
        private pagerService:PagerService,
        private route:ActivatedRoute,
        private userService:UserService,
        private filterPipe:Service360FilterPipe,
    ){
        if (!this.adalService.getCachedToken()) {
            setTimeout(() => {
                this.router.navigate(["login"]);
            }, 100);
        }
        appLoader.close();
        route.params.subscribe((params)=>{
            this.ProductId=params['productId']
        })
        this.getUserRights();
        this.getService360LicenseDisplayDetail();
        
    }

    getUserRights(){
        let UserId=Number(localStorage.getItem('userid'))
        this.userService.getUserLicenseRightById(UserId,this.ProductId).subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.IsAddEdit=data.DataObject.IsAddEdit;
                this.IsDelete=data.DataObject.IsDelete;
            }
        })
    }
    setPage(page: number) {
        this.service360LicenseList=[...this.originalService360LicenseList];
        this.applySort();
        this.filteredService360LicenseList=this.filterPipe.transform(this.service360LicenseList,this.filterBillToName,this.filterShipToName,this.filterLicenseKey)
        this.pager = this.pagerService.getPager(this.filteredService360LicenseList.length, page);
        this.pagedItems = this.filteredService360LicenseList.slice(this.pager.startIndex, this.pager.endIndex + 1);
        this.errorMessage=(this.pagedItems.length==0)?"No records found.":"";
    }
    openGenerateNewLicenseRequestDialog(){
        let generateNewLicenseRequestDialogRef:MdDialogRef<GenerateService360LicenseComponent>=this.dialog.open(GenerateService360LicenseComponent,{
            data:{
                Service360LicenseData: this.originalService360LicenseList,
                SelectedLicenseDetail:null
            },
            disableClose:true
        });
        generateNewLicenseRequestDialogRef.afterClosed().subscribe((result)=>{
            this.originalService360LicenseList=result;
            this.service360LicenseList=[...this.originalService360LicenseList];
            this.setPage(1);
        })
    }
    exportToCSV(){
            let jsonData:Array<any>=[];
            if(this.service360LicenseList){
                this.service360LicenseList.forEach(element => {
                    jsonData.push({
                        BillToName:element.BillToName,
                        BillToAddress1:element.BillToAddress1,
                        BillToAddress2:element.BillToAddress2,
                        BillToCity:element.BillToCity,
                        BillToState:element.BillToState,
                        BillToZipcode:element.BillToZipcode,
                        BillToCountryCode:element.BillToCountryCode,
                        ShipToName:element.ShipToName,
                        ShipToAddress1:element.ShipToAddress1,
                        ShipToAddress2:element.ShipToAddress2,
                        ShipToCity:element.ShipToCity,
                        ShipToState:element.ShipToState,
                        ShipToZipcode:element.ShipToZipcode,
                        ShipToCountryCode:element.ShipToCountryCode,
                        LicenseKey:element.LicenseKey,
                        SalesOrderNo:element.SalesOrderNo,
                        ExpiryDate:element.ExpiryDate,
                        NoOfInstallations:element.NoOfInstallation,
                        TotalActivation:element.NoOfActivations
                    })
                });
                this.exportService.exportToCsv(jsonData,'Service360')
            }
            else{
                Swal.fire({
                    title:'No data',
                    text:'There is no data available to export to CSV file.',
                    showCloseButton:true,
                    showConfirmButton:true,
                    confirmButtonColor:'#FFCA28'
                })
            }
        }
    clearSearch(){
        this.filterBillToName=this.searchBillToName='';
        this.filterShipToName=this.searchShipToName='';
        this.filterLicenseKey=this.searchLicenseKey='';
        this.setPage(1);
        // this.getBillingShippingDetail('SO-0002995');
    }
    search(){
        this.filterBillToName=this.searchBillToName;
        this.filterShipToName=this.searchShipToName;
        this.filterLicenseKey=this.searchLicenseKey;
        this.setPage(1);
    }
    getService360LicenseDisplayDetail(){
        this.appLoader.open();
        this.licenseService.getService360LicenseDisplayDetail().subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.originalService360LicenseList=data.DataObject;
                this.service360LicenseList=[...this.originalService360LicenseList];
                this.setPage(1);
                this.buildSearchArray();
            }
            else{

            }
            this.appLoader.close();
        });
    }
    onEdit(row){
        let editService360LicenseRequest:MdDialogRef<GenerateService360LicenseComponent>=this.dialog.open(GenerateService360LicenseComponent,{
            data:{
                Service360LicenseData: this.originalService360LicenseList,
                SelectedLicenseDetail:row
            },
            disableClose:true
        });
        editService360LicenseRequest.afterClosed().subscribe((result)=>{
            this.originalService360LicenseList=result;
            this.service360LicenseList=[...this.originalService360LicenseList];
            this.setPage(this.pager.currentPage);
        })
    }
    buildSearchArray(){
        const BillToArray=this.service360LicenseList.map(item=>item.BillToName)
        const ShipToArray=this.service360LicenseList.map(item=>item.ShipToName)
        this.BillToList=Array.from(new Set(BillToArray)).sort();
        this.ShipToList=Array.from(new Set(ShipToArray)).sort();
    }
    viewActivationHistory(row){
        let service360ViewActivationDialogRef:MdDialogRef<Service360ViewActivationDetailComponent>=this.dialog.open(Service360ViewActivationDetailComponent,{
            width:'40%',
            height:'60%',
            data:{
                SelectedLicenseDetail:row
            }
        })
    }
    deactivateLicense(row){
        Swal.fire({
            title:"Deactivate License",
            text:"Are you sure you want to deactivate the license?",
            confirmButtonText:"Yes",
            confirmButtonColor:"#FFCA28",
            cancelButtonText:"No",
            showCloseButton:true,
            showConfirmButton:true,
            showCancelButton:true
        }).then((result)=>{
            if(result.isConfirmed){
                this.appLoader.open();
                let model={
                    LicenseId:row.LicenseId,
                    UpdatedBy:Number(localStorage.getItem('userid'))
                }
                this.licenseService.deactiveService360License(model).subscribe((data)=>{
                    if(!data.IsError && data.DataObject!=null){
                        this.originalService360LicenseList=data.DataObject;
                        this.service360LicenseList=[...this.originalService360LicenseList];
                        this.setPage(this.pager.currentPage);
                        this.appLoader.close();
                        this.snackBar.open("License Deactivated successfully.","",{
                            duration:2000,
                        });
                    }
                    else{
                        this.appLoader.close();
                    }
                })
            }
        })
    }
    
    activateLicense(row){
        Swal.fire({
            title:"Activate License",
            text:"Are you sure you want to activate the license?",
            confirmButtonText:"Yes",
            confirmButtonColor:"#FFCA28",
            cancelButtonText:"No",
            showCloseButton:true,
            showConfirmButton:true,
            showCancelButton:true
        }).then((result)=>{
            if(result.isConfirmed){
                this.appLoader.open();
                let model={
                    LicenseId:row.LicenseId,
                    UpdatedBy:Number(localStorage.getItem('userid'))
                }
                this.licenseService.activateService360License(model).subscribe((data)=>{
                    if(!data.IsError && data.DataObject!=null){
                        this.originalService360LicenseList=data.DataObject;
                        this.service360LicenseList=[...this.originalService360LicenseList];
                        this.setPage(this.pager.currentPage);
                        this.appLoader.close();
                        this.snackBar.open("License activated successfully.","",{
                            duration:2000,
                        });
                    }
                    else{
                        this.appLoader.close();
                    }
                })
            }
        })
    }

     onSortChange(event){
        this.currentSortColumn = event.column;
        this.currentSortOrder = event.order;
        this.setPage(this.pager.currentPage);
        
    }
    applySort(){
        if(!this.currentSortColumn || !this.currentSortOrder) return;
        this.service360LicenseList=this.service360LicenseList.sort((a,b)=>
            {
                if(this.currentSortOrder==='asc'){
                    a[this.currentSortColumn]=a[this.currentSortColumn] || '';
                    return a[this.currentSortColumn].localeCompare(b[this.currentSortColumn])
                }
                else if (this.currentSortOrder==='desc'){
                    b[this.currentSortColumn]=b[this.currentSortColumn] || '';
                    return b[this.currentSortColumn].localeCompare(a[this.currentSortColumn])
                }
                else {
                    return 0;
                }
            }
        )
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/service360/service360.component.ts